import { Component, NgModule } from "@angular/core";
import { ModalController, NavController, NavParams, ToastController } from '@ionic/angular';
import { IProperty } from "src/app/interfaces/property.interface";
import { IUser } from "src/app/interfaces/user.interface";
import { UserAdminService } from "src/app/services/user.service";

@Component({
	selector: 'property-admin-modal',
	templateUrl: 'property-admin-modal.html',
	styleUrls: ['./property-admin-modal.scss'],
})

export class PropertyAdminModal {
	property: IProperty
	eccovals: any[]
	user: IUser
	propertyJson: string

	get address() { return this.property.search_formatted_address ? this.property.search_formatted_address.replace(', USA', '') : this.property.formatted_address }
	get cma() { return !this.property ? 0 : this.property.eccovals[0].cmaprice }
	get propertyValu() { return !this.property ? 0 : this.property.eccovals[0].priceadjustment }

	constructor(
		public viewCtrl: ModalController,
		public params: NavParams,
		public userService: UserAdminService,
		public nav: NavController,
		public toastCtrl: ToastController
	) {
		this.property = params.get("property");
		this.propertyJson = JSON.stringify(this.property, null, 4)
		this.loadUser()
		console.log(`${this.property.formatted_address}:\n`, this.property)
	}

	async loadUser() {
		try {
			this.user = await this.userService.findById(this.property.created_by).toPromise()
		} catch (e) {
			console.error('Error loading user: ', e)
		}
	}

	close() {
		this.viewCtrl.dismiss({ dismissed: true })
	}

	viewProperty() {
		console.log("todo")
	}

	routeToUserDetails(userid: string) {
		this.nav.navigateForward(`/property/${this.property._id}?userid=${userid}`)
		this.close()
	}

	async copyToClipboard() {
		let message = 'Successfully copied property data'
		try {
			await window.navigator['clipboard'].writeText(this.propertyJson)
		} catch (e) {
			message = 'Error copying property data'
			console.error('Error: ', e)
		}
		await this.toastCtrl.create({ message, duration: 3000, position: 'top'}).then(t => t.present())
	}
}
